/**
 * AT-13 — Settings Disclosure section.
 *
 * Read-only mirror of the Onboarding install-consent phase. Renders the
 * canonical `InstallConsentSummary` block inside the Settings page so the
 * user can re-read what their wallet shares + what is stripped. Both
 * surfaces import from `install-consent-copy.ts` — byte-equivalence is
 * structural, not asserted at runtime.
 *
 * No interactive form controls. Editable disclosure preferences are
 * Slice 3 scope (CONTEXT.md line 100); the canonical-copy module's
 * `defaultsNote` already hints "land in a future release" so the user
 * understands the limitation.
 */

import { InstallConsentSummary } from '../install-consent/InstallConsentSummary';

export function SettingsDisclosureSection() {
  return (
    <div data-testid="settings-disclosure-section" className="space-y-4">
      <InstallConsentSummary />
    </div>
  );
}
